<template>
  <div class="customer">
    <van-tabs v-model="tabType" color="#599d00">
      <van-tab :title="store.langConfig['SubmitQuestion']" :to="{path: '/customer/list', query: {type: 0}}"></van-tab>
      <van-tab :title="store.langConfig['MyReqQuestion']" :to="{path: '/customer/list', query: {type: 1}}"></van-tab>
    </van-tabs>
    <keep-alive include="QsDetail">
      <!-- 仅缓存detail数据 -->
      <router-view :store="newStore" :key="$route.query.questionId || ''"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'Customer',
  props: {
    store: Object
  },
  data(){
    return {
      // 0->提交问题，1->我的提问
      tabType: 0,
      newStore: ''
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.name === 'qs-list') {
          // 注意默认值与子路由保持一致
          this.tabType = Number(to.query.type || 0)
        }
      }
    },
    store: {
      deep: true,
      immediate:true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.newStore = newVal
        }
      }
    }
  }
}
</script>

